<template>
  <div id="shipping-main">
    <div id="shipping-header">
      <Header></Header>
    </div>
    <div id="shipping-contents">
      <Upload v-show="stepStatus.Index === ShippingStep.Step1.Index"></Upload>
      <Select v-show="stepStatus.Index === ShippingStep.Step2.Index"></Select>
      <Editor v-show="stepStatus.Index === ShippingStep.Step3.Index"></Editor>
      <Receipt v-show="stepStatus.Index === ShippingStep.Step4.Index"></Receipt>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { ShippingStep } from '@/const/const'
import Header from '@/components/shipping/Header.vue'
import Upload from '@/components/shipping/Upload.vue'
import Select from '@/components/shipping/Select.vue'
import Editor from '@/components/shipping/Editor.vue'
import Receipt from '@/components/shipping/Receipt.vue'

export default defineComponent({
  props: {
    stepStatus: {
      required: true
    }
  },
  components: {
    Header,
    Upload,
    Select,
    Editor,
    Receipt
  },
  setup (props) {
    return {
      ShippingStep
    }
  }
})

</script>

<style scoped lang="scss">
#shipping-main {
  background-color: #DFD8E7;
  height: 100%;
  width: 100%;

  #shipping-header {
    position: absolute;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    width: 100%;
    height: 15%;
  }
  #shipping-contents {
    position: absolute;
    top: 18%;
    width: 100%;
    height: 80%;
  }
  #shipping-contents2 {
    position: relative;
    top: 18%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    width: 80%;
    height: 80%;
    margin-left: auto;
    margin-right: auto;
  }

}
  .table tr:hover td{
    color: green;
    background: #F5E974;
  }
</style>
